import { render, staticRenderFns } from "./GuideDetail.vue?vue&type=template&id=42ccb756&scoped=true"
import script from "./GuideDetail.vue?vue&type=script&lang=js"
export * from "./GuideDetail.vue?vue&type=script&lang=js"
import style0 from "./GuideDetail.vue?vue&type=style&index=0&id=42ccb756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccb756",
  null
  
)

export default component.exports